module.exports = __webpack_public_path__ + "static/header-logo-8974b8ae658f704a5b48a2d039b8ad93.gif";